/** Rotating lines shown while Image Studio generations run. */
export const IMAGE_GENERATION_SAYINGS = [
  "Bringing your ideas to life…",
  "Breathing life into your vision…",
  "Sketching the first strokes…",
  "Mixing light and shadow…",
  "Composing the perfect frame…",
  "Painting pixels with intention…",
  "Warming up the creative engine…",
  "Translating words into visuals…",
  "Finding the right mood…",
  "Tuning colors to your prompt…",
  "Building atmosphere and depth…",
  "Capturing the moment you imagined…",
  "Refining details frame by frame…",
  "Giving shape to your story…",
  "Balancing composition and clarity…",
  "Letting creativity take the wheel…",
  "Sculpting light across the scene…",
  "Drawing inspiration from your words…",
  "Crafting something worth sharing…",
  "Zooming in on what matters…",
  "Setting the scene just right…",
  "Weaving texture into the picture…",
  "Holding focus so the story lands…",
  "Turning imagination into imagery…",
  "Aligning every element with care…",
  "Polishing highlights and soft edges…",
  "Listening closely to your prompt…",
  "Summoning the right visual vibe…",
  "Layering meaning into the canvas…",
  "Almost ready — staying patient…",
  "Finishing the finishing touches…",
  "Making silence visible…",
  "Discovering unexpected beauty…",
  "Framing emotion in every pixel…",
  "Gently guiding the model…",
  "Keeping the vision sharp…",
  "Illuminating the unseen details…",
  "Shaping silence into spectacle…",
  "Matching style to substance…",
  "Stretching ideas into presence…",
  "Unlocking the image within…",
  "Settling light where it belongs…",
  "Coaxing clarity from chaos…",
  "Rendering your imagination…",
  "Nurturing the scene into form…",
  "Anchoring the story in color…",
  "Inviting wonder into the frame…",
  "Softening noise, sharpening intent…",
  "Assembling your world, carefully…",
  "Creating something only you asked for…",
];

/**
 * @param {number} currentIndex
 * @param {number} length
 */
export function nextImageSayingIndex(
  currentIndex,
  length = IMAGE_GENERATION_SAYINGS.length,
) {
  if (length <= 1) return 0;
  let next = Math.floor(Math.random() * length);
  if (next === currentIndex) next = (next + 1) % length;
  return next;
}
